export type ReportTaskFilter = { authorizedUserId: string; planIds: string[] };

export function reportFilterQuery(selection: ReportTaskFilter & { dateFrom: string; dateTo: string; status: string }) {
  const query = new URLSearchParams({ dateFrom: selection.dateFrom, dateTo: selection.dateTo });
  if (selection.status) query.set("status", selection.status);
  selection.planIds.forEach((id) => query.append("planIds", id));
  if (selection.authorizedUserId) query.set("authorizedUserId", selection.authorizedUserId);
  return query;
}

export function reportDateRange(days: number | "yesterday", today: string) {
  const start = new Date(`${today}T00:00:00Z`);
  if (days === "yesterday") {
    start.setUTCDate(start.getUTCDate() - 1);
    const yesterday = start.toISOString().slice(0, 10);
    return { dateFrom: yesterday, dateTo: yesterday };
  }
  start.setUTCDate(start.getUTCDate() - days + 1);
  return { dateFrom: start.toISOString().slice(0, 10), dateTo: today };
}

export function readReportTaskFilter(storageKey: string, search: string): ReportTaskFilter {
  let saved: ReportTaskFilter = { authorizedUserId: "", planIds: [] };
  try {
    const value = JSON.parse(localStorage.getItem(storageKey) || "null");
    if (value && typeof value.authorizedUserId === "string" && Array.isArray(value.planIds)
      && value.planIds.every((id: unknown) => typeof id === "string")) {
      saved = { authorizedUserId: value.authorizedUserId, planIds: [...new Set<string>(value.planIds.filter(Boolean))] };
    }
  } catch {
    // Filtering still works when browser storage is unavailable or contains invalid data.
  }
  const params = new URLSearchParams(search);
  const explicitIds = [...params.getAll("planIds"), ...params.getAll("planId")].filter(Boolean);
  return explicitIds.length ? { authorizedUserId: "", planIds: [...new Set(explicitIds)] } : saved;
}

export function saveReportTaskFilter(storageKey: string, value: ReportTaskFilter) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(value));
  } catch {
    // Browsers may disable persistent storage; keep the current selection usable.
  }
}
